__turbopack_context__.v({
  "hover": "HoverActionButton-module-scss-module__I_Zaha__hover",
  "icon": "HoverActionButton-module-scss-module__I_Zaha__icon",
  "label": "HoverActionButton-module-scss-module__I_Zaha__label",
  "white": "HoverActionButton-module-scss-module__I_Zaha__white",
  "wrapper": "HoverActionButton-module-scss-module__I_Zaha__wrapper",
});
